module.exports = __webpack_public_path__ + "img/esoofmini.299f9af6.jpg";